<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>video_library</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.eLearning' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <!--      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"-->
      <!--           fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">-->
      <!--        <label for="search" class="mr-8">-->
      <!--          <mat-icon class="secondary-text">search</mat-icon>-->
    <!--        </label>-->
    <!--        <mat-form-field floatLabel="never" fxFlex="1 0 auto">-->
    <!--          <input id="search" [(ngModel)]="term" matInput  placeholder="{{'main.search' | translate}}">-->
  <!--        </mat-form-field>-->
<!--      </div>-->
<!-- / SEARCH -->
<div>
  <button mat-raised-button
    [routerLink]="'/pages/eLearning/detail'"
    class="add-product-button mat-white-bg my-12 mt-sm-0">
    <span>{{'add_new' | translate}}</span>
  </button>
</div>


</div>
<!-- / HEADER -->
<!-- CONTENT CARD -->
<div class="content-card mat-white-bg">
  @if (spaces && spaces.length) {
    <div class="spaces">
      @for (sp of spaces; track sp) {
        @if (sp.boards && sp.boards.length) {
          <div class="cat-grid">
            <mat-accordion>
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="cat-header">
                      <span>{{sp.name}}</span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="categories">
                  @if (sp.boards && sp.boards.length) {
                    @for (br of sp.boards; track br) {
                      <div class="cat-grid">
                        <mat-accordion>
                          <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <div class="cat-header">
                                  <span>{{br.name}}</span>
                                </div>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (elr of br.elearning; track elr) {
                              <div class="cat-content">
                                <div class="name">
                                  <div>{{elr.title}}</div>
                                  @if (elr.learnCategory) {
                                    <div class="learn-categories">
                                      @for (lcat of elr.learnCategory; track lcat) {
                                        <div class="learn-category"
                                          [style.background-color]="lcat.color">
                                          &#9679;&nbsp;&nbsp;&nbsp;{{lcat.name}}
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="icons">
                                  @if (elr.onlyPreview) {
                                    <mat-icon style="color: orange" (click)="preview(elr)" class="sub-mat-icon">visibility</mat-icon>
                                  }
                                  @if (!elr.onlyPreview) {
                                    <mat-icon style="color: orange" (click)="open(elr)" class="sub-mat-icon">edit</mat-icon>
                                  }
                                </div>
                              </div>
                            }
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    }
                  }
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
      }
    </div>
  }

  <!--      <div style="overflow: auto; display: flex">-->
  <!--        <div class="tutorials">-->
  <!--          <div class="tutorial-wraper">-->
  <!--            <div class="tutorial-item" *ngFor="let item of eLearnings" (click)="open(item)">-->
  <!--              <section class="title">-->
  <!--                <p>{{item.title}}-->
  <!--                  <button (click)="open(item)"-->
  <!--                          style="    position: absolute; right: 15px; top: 15px" mat-fab-->
  <!--                          [ngStyle]="{'background-color': 'green'}">-->
  <!--                    <mat-icon style="    color: white;">edit</mat-icon>-->
<!--                  </button>-->
<!--                </p>-->

<!--              </section>-->
<!--              <div [innerHTML]="item.description">-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
</div>


<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>




